<template>
    <div class="flex">
        <div class="deliveryAddressCard__action border-b w-8/12">
            <p class="no-margin" v-text="label"></p>
        </div>
        <div class="deliveryAddressCard__action w-4/12 border-l border-b
            flex items-center justify-between">
            <button
                class="deliveryAddressCard__quantityButton"
                @click="decrementQuantity"
                :disabled="shouldDecrementBeDisabled">
                <img src="@/assets/images/decoration/icon-minus-circle.svg" alt="Decrement">
            </button>
            <p class="no-margin" v-text="quantity"></p>
            <button
                class="deliveryAddressCard__quantityButton"
                @click="incrementQuantity"
                :disabled="shouldIncrementBeDisabled">
                <img src="@/assets/images/decoration/icon-plus-circle.svg" alt="Increment">
            </button>
        </div>
    </div>
</template>

<script>
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import { CSPageEvents } from '@/helpers/GAHelpers';

let subscriptionService = new SubscriptionService();

export default {
    name: 'AddressManageQuantity',
    data() {
        return {
            processing: false,
        };
    },
    props: {
        subscription: {
            required: true,
            type: Object,
        },
        label: {
            default: 'Boxes per delivery:',
            type: String,
        },
    },
    methods: {
        incrementQuantity() {
            this.toggleProcessing();
            CSPageEvents('Increase-box-number');
            subscriptionService
                .updateSubscriptionQuantity(this.subscription.id, this.subscription.quantity + 1)
                .then(() => this.handleSuccessfulQuantityUpdate());
        },

        decrementQuantity() {
            this.toggleProcessing();
            CSPageEvents('Reduce-box-number');
            subscriptionService
                .updateSubscriptionQuantity(this.subscription.id, this.subscription.quantity - 1)
                .then(() => this.handleSuccessfulQuantityUpdate());
        },

        toggleProcessing() {
            this.processing = !this.processing;
        },

        handleSuccessfulQuantityUpdate() {
            this.$store.dispatch('subscription/fetchAllSubscriptions', true);
            this.toggleProcessing();
        },
    },
    computed: {
        shouldDecrementBeDisabled() {
            return this.processing === true || this.quantity === 1;
        },

        shouldIncrementBeDisabled() {
            return this.processing === true || this.quantity >= 4;
        },
        quantity() {
            return parseInt(this.subscription.quantity);
        },
    },
};
</script>
